import { useI18n } from '../../../i18n';
// ============================================
// PromotionFilterBar Component
// ============================================

interface PromotionFilterBarProps {
  searchQuery: string;
  statusFilter: string;
  onSearchChange: (v: string) => void;
  onStatusFilterChange: (v: string) => void;
}

export function PromotionFilterBar({
  searchQuery,
  statusFilter,
  onSearchChange,
  onStatusFilterChange,
}: PromotionFilterBarProps) {
  const { t } = useI18n();
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="relative flex-1 max-w-md">
        <svg
          className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t('searchByCodeOrName')}
          enterKeyHint="search"
          onKeyDown={(e) => { if (e.key === 'Enter') e.currentTarget.blur(); }}
          className="h-10 w-full rounded-lg border border-slate-200 bg-white pl-9 pr-3 text-sm focus:border-blue-400 focus:outline-none focus:ring-1 focus:ring-blue-400"
        />
      </div>
      <select
        value={statusFilter}
        onChange={(e) => onStatusFilterChange(e.target.value)}
        className="h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-700 focus:border-blue-400 focus:outline-none focus:ring-1 focus:ring-blue-400"
      >
        <option value="">{t('allStatus')}</option>
        <option value="DRAFT">{t('draft') || 'Draft'}</option>
        <option value="ACTIVE">{t('promotionsActive')}</option>
        <option value="INACTIVE">{t('promotionsInactive')}</option>
        <option value="EXPIRED">{t('expired')}</option>
      </select>
    </div>
  );
}
